<div #gridEl class="grid-stack">
  <ng-content></ng-content>
</div>
